export default "__VITE_ASSET__1018cc75__"